/**
 * Tenant IDs currently under maintenance.
 * Users selecting these tenants will see a maintenance page.
 * This cannot be bypassed - it's separate from feature flags.
 *
 * To put tenants into maintenance mode, add their IDs to this array:
 * @example
 * export const maintenanceTenants: string[] = ['league', 'tenant-being-migrated'];
 */
export const maintenanceTenants: string[] = [];

/**
 * Checks if a tenant is currently under maintenance.
 * This check cannot be bypassed by users.
 *
 * @param tenantId - The tenant ID to check
 * @returns Whether the tenant is under maintenance
 */
export const isTenantUnderMaintenance = (tenantId: string): boolean =>
  maintenanceTenants.includes(tenantId);
